module.exports = __webpack_public_path__ + "img/图01.2200096f.jpg";